import { Checkbox, Stack, TextField } from '@fluentui/react';
import { observer } from 'mobx-react';
import { ProvisionProfileEditorState } from './ProvisionProfileEditor';

import { InfoTooltipLabel } from '../../controls/InfoTooltipLabel';

function ProfileItemAttachments({ state }: { state: ProvisionProfileEditorState }) {
	
	return (<>
			<Stack>
				

				<InfoTooltipLabel label='Save list item attachments to workspace' title='Determines if attachments are moved to the workspace after provisioning.'>
					<Checkbox
						label="Move attachments to workspace after provisioning"
						checked={state.MoveAttachmentsToWorkspace}
						onChange={(e, checked) => { state.setMoveAttachmentsToWorkspace(checked?.valueOf() ?? false); } }
					/>
				</InfoTooltipLabel>

				{ state.MoveAttachmentsToWorkspace ?
					<InfoTooltipLabel label='Library or folder to move to' title={`Specify a document library or folder path for attachments to be moved to. For example  e.g. "Shared Documents" or  e.g. "Correspondence/Attachments". The library or folder must exist or the move will not take place. If your workspace is a library or folder, this is optional.`}>
						<TextField
							value={state.MoveAttachmentsToWorkspacePath}
							onChange={(e, newValue) => { state.setMoveAttachmentsToWorkspacePath(newValue || ''); }}
						/>
					</InfoTooltipLabel>
					: <></>
				}

			</Stack>
		</>
	);
}

export default observer(ProfileItemAttachments);
